import { AdminAccountSummary, AdminUser } from '../types/auth';
import { api, seg } from './client';

/**
 * Platform-wide administration — system-admin only, gated on the server by
 * `SystemAdminAccessService`. Never account-scoped: these calls see and manage every
 * user and account, not just the caller's own.
 */

export const fetchAdminUsers = (): Promise<AdminUser[]> => api.get<AdminUser[]>('/admin/users');

export const fetchAdminAccounts = (): Promise<AdminAccountSummary[]> =>
  api.get<AdminAccountSummary[]>('/admin/accounts');

/** Issues a one-time password-reset link for any registered user. */
export const issueAdminResetLink = (userId: string): Promise<{ link: string }> =>
  api.post<{ link: string }>(`/admin/users/${seg(userId)}/reset-password-link`, {});

export const setUserEnabled = (userId: string, enabled: boolean): Promise<void> =>
  api.post<void>(`/admin/users/${seg(userId)}/${enabled ? 'enable' : 'disable'}`, {});

export const setUserSystemAdmin = (userId: string, isAdmin: boolean): Promise<void> =>
  isAdmin
    ? api.post<void>(`/admin/users/${seg(userId)}/system-admin`, {})
    : api.delete<void>(`/admin/users/${seg(userId)}/system-admin`);
